import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useStaffInfo = () => {
  const handleNetworkError = useHandleNetworkError("Error fetching staff info");

  const userId = sessionStorage.getItem("userId");

  const query = useQuery({
    queryKey: ["staffInfo", userId],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance(true);
      const response = await axiosInstance.get(`/api/v1/whoami`);
      return response.data;
    },
    enabled: !!sessionStorage.getItem("accessToken"),
    staleTime: 1000,
    retry: (failureCount, error) => {
      // Don't retry on 403 — the user is forbidden
      if (error?.response?.status === 403) return false;
      return failureCount < 3;
    },
  });

  useEffect(() => {
    if (query.error) {
      handleNetworkError(query.error);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.error]);

  return query;
};
